import { IKycData } from 'shared/interfaces/i-api-kyc'
import { useTranslation } from 'react-i18next'

export const PepInformationBalticForm = (data: IKycData) => {
	const { t } = useTranslation(['translation', 'forms'])

	return {
		fieldSetName: t('forms:PEPInfoHeader'),
		formName: data.customerType,
		description: t('forms:PEPInfoDescription'),
		show: true,
		visible: true,
		col: 12,
		controls: [
			{
				options: [
					{
						value: 'false',
						label: t('No'),
					},
					{
						value: 'true',
						label: t('Yes'),
					},
				],
				controlName: 'politicallyExposedPerson',
				type: 'checkbox',
				label: t('forms:PoliticallyExposedPerson'),
				value: data.politicallyExposedPerson,
				col: 12,
				visible: true,
				require: true, 
			},
		],
	}
}